import { useState, useEffect } from "react";
import { Link } from "react-scroll";

function Navbar() {
  // nav bar active
  const [navActive, setNavActive] = useState(false);

  // open nav
  const toggleNav = () => {
    setNavActive(!navActive);
  };

  // close nav
  const closeMenu = () => {
    setNavActive(false);
  };

  //
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 500) {
        closeMenu;
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 1200) {
      closeMenu;
    }
  }, []);
  const downloadResume = () => {
    const link = document.createElement("a");
    link.href = "./Samrudhi_Margi.pdf"; // Update with your actual file path
    link.download = "Samrudhi_Margi.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <nav className={`navbar ${navActive ? "active" : ""}`}>
      <h2 className="navbar--logo">Samrudhi Margi</h2>
      <a
        className={`nav__hamburger ${navActive ? "active" : ""}`}
        onClick={toggleNav}
      >
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
        <span className="nav__hamburger__line"></span>
      </a>
      <div className={`navbar--items ${navActive ? "active" : ""}`}>
        <ul>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="heroSection"
              className="navbar--content"
              aria-label="LinkedIn profile"
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="AboutMe"
              className="navbar--content"
            >
              About Me
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="MyPortfolio"
              className="navbar--content"
            >
              Projects
            </Link>
          </li>
          <li>
            <Link
              onClick={closeMenu}
              activeClass="navbar--active-content"
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
              to="Contact"
              className="navbar--content"
            >
              Contact
            </Link>
          </li>
          <li>
            <li>
              <button
                onClick={() => {
                  downloadResume();
                  closeMenu();
                }}
                className="btn btn-outline-primary navbar--content resume-mob"
              >
                Download Resume
              </button>
            </li>
          </li>
        </ul>
      </div>
      {/* <div> */}
      {/* <Link 
            onClick={closeMenu} activeClass="navbar--active-content" 
            spy={true} 
            smooth={true} 
            offset={-70} 
            duration={500} 
            to="Contact"
            className="btn btn-outline-primary"
            >
            Say Hello
        </Link> */}
      <Link
        onClick={downloadResume}
        activeClass="navbar--active-content"
        className="btn btn-outline-primary resume-d"
      >
        Resume
      </Link>
      {/* </div> */}
    </nav>
  );
}

export default Navbar;
